import { styled } from '@moonpig/launchpad-utils'

export const ConciergeChatBody = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
`

export const ConciergeChatLoadingWrapper = styled.div`
  display: contents;
`
